import { ChatMarkdown } from '@/app/ui/chat-markdown';
import ViewHelpMarkdownLink from '@/app/helpArticle/ViewHelpMarkdownLink';

// The test ids the help assistant's specs read; the styling is ChatMarkdown's.
const answerComponents = {
  ol: ({ children }) => (
    <ol className="my-2 list-decimal space-y-1 pl-5 leading-6" data-testid="help-assistant-answer-ordered-list">
      {children}
    </ol>
  ),
  li: ({ children }) => (
    <li className="pl-0.5" data-testid="help-assistant-answer-list-item">
      {children}
    </li>
  ),
  a: ViewHelpMarkdownLink,
  strong: ({ children }) => (
    <strong className="font-semibold" data-testid="help-assistant-answer-strong">
      {children}
    </strong>
  )
};

/** An assistant answer's Markdown. */
const Answer = ({ markdown }) => {
  return <ChatMarkdown markdown={markdown} components={answerComponents} />;
};

export default Answer;
